export enum FeatureEnum {
    InversorAndCombiners = 'InversorAndCombiners',
    Estacao = 'Estacao',
    Medidor = 'Medidor',
    Rele = 'Rele',
    Trackers = 'Trackers',
    CommunicationMap = 'CommunicationMap',
    TrackersMap = 'TrackersMap',
    UnifilarDiagram = 'UnifilarDiagram',
}